import React from 'react';
//material
import {Card, CardContent, withStyles, Grid} from '@material-ui/core';
//styles
import styles from './notice-card-styles';

const NoticeCardView = (props) => {
  const {classes, notices} = props;

  return (
    <Card>
      <CardContent>
        <div className={classes.title}>
          Sponsored By
        </div>

        <Grid container spacing={2} className={classes.grid}>
          {
            notices.map((n, i) =>
              <Grid item xs={12} sm={4} key={i}>
                <div className={classes.imgContainer}>
                  <img
                    className={classes.img}
                    src={n.logoUrl}/>
                </div>

                <div className={classes.name}>
                  {n.name}
                </div>

                <div className={classes.subtitle}>
                  {n.header}
                </div>
              </Grid>)
          }
        </Grid>
      </CardContent>
    </Card>
  );
};

export default withStyles(styles) (NoticeCardView);
